/* eslint-disable react/prop-types */
import React from 'react';
import ReactPlayer from 'react-player';

export const Video = (props) => {
  const { url } = props;

  if (!url) {
    return (
      <div>
        <p>No video.</p>
      </div>
    );
  }

  return (
    <ReactPlayer
      url={url}
      width={props.width || '100%'}
      height={props.height || '100%'}
      style={props.style || ''}
      controls={true}
      config={{
        file: {
          attributes: {
            controlsList: 'nodownload',
          },
        },
      }}
    />
  );
};

export default Video;
